import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["inline", "token", "tokenOffset", "spacing", "align", "reverse", "stackBelow", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, spacing } from 'styles/globals';
import { createStyleFunction, getSpacing, getPropNamesFromPropDefinition, getPropFilter } from 'utils/ui';
import { marginPropsDef, sizePropsDef } from 'styles/styleProps';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var alignMap = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};
var flagPropNames = ['align', 'spacing', 'reverse', 'stackBelow', 'offset'];
var shouldForwardProp = getPropFilter([].concat(_toConsumableArray(getPropNamesFromPropDefinition([].concat(_toConsumableArray(marginPropsDef), _toConsumableArray(sizePropsDef)))), flagPropNames));
var wrapperStyleProps = createStyleFunction([].concat(_toConsumableArray(sizePropsDef), _toConsumableArray(marginPropsDef)));
var Wrapper = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Flag__Wrapper",
  componentId: "sc-3oh54b-0"
})(["display:flex;align-items:", ";", " ", " ", ""], function (p) {
  return p.align && alignMap[p.align];
}, wrapperStyleProps, function (p) {
  return p.reverse && css(["flex-direction:row-reverse;"]);
}, function (p) {
  return p.stackBelow && css(["@media (max-width:", "){flex-direction:column;align-items:center;text-align:center;}"], breakpoints[p.stackBelow]);
});
var Token = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !flagPropNames.includes(prop);
  }
}).withConfig({
  displayName: "Flag__Token",
  componentId: "sc-3oh54b-1"
})(["flex:none;", " ", " ", ";"], function (p) {
  return p.reverse ? css(["margin-left:", ";"], function (p) {
    return spacing[p.spacing];
  }) : css(["margin-right:", ";"], function (p) {
    return spacing[p.spacing];
  });
}, function (p) {
  return p.offset && css(["margin-top:", ";"], getSpacing(p.offset, p.theme));
}, function (p) {
  return p.stackBelow && "\n\t\t\t\t@media (max-width: ".concat(breakpoints[p.stackBelow], ") {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tmargin-bottom: ").concat(spacing[p.spacing], "\n\t\t\t\t}\n\t\t\t");
});
var Content = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !flagPropNames.includes(prop);
  }
}).withConfig({
  displayName: "Flag__Content",
  componentId: "sc-3oh54b-2"
})(["flex:1 1 auto;min-width:0;width:100%;", ""], function (p) {
  return p.stackBelow && css(["@media (max-width:", "){width:auto;}"], breakpoints[p.stackBelow]);
});
var Flag = function Flag(_ref) {
  var inline = _ref.inline,
    token = _ref.token,
    tokenOffset = _ref.tokenOffset,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 's' : _ref$spacing,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    reverse = _ref.reverse,
    stackBelow = _ref.stackBelow,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var as = inline ? 'span' : undefined;
  return /*#__PURE__*/_jsxs(Wrapper, _objectSpread(_objectSpread({
    as: as,
    align: align,
    stackBelow: stackBelow,
    reverse: reverse
  }, otherProps), {}, {
    children: [token && /*#__PURE__*/_jsx(Token, {
      as: as,
      spacing: spacing,
      offset: tokenOffset,
      stackBelow: stackBelow,
      reverse: reverse,
      children: token
    }), /*#__PURE__*/_jsx(Content, {
      as: as,
      stackBelow: stackBelow,
      children: children
    })]
  }));
};
export default Flag;